import { yup } from '@framework/validation/initYup.ts';
import { type NullableObject } from '@framework/validation/NullableObject.ts';
import { type AlboConfigurazioneTipoCampoDTO } from '../configuration/api/schemas/alboConfigurazioneTipoCampoDTO.ts';
import { type RegisterRecordFieldVisibility } from '../schema/RegisterRecordFieldVisibility.ts';
import { applyRecordTypesFieldValidators } from './applyRecordTypesFieldValidators.ts';

/**
 * Crea uno schema di validazione Yup per i parametri di ricerca di un albo,
 * includendo dinamicamente i campi custom basati sulla configurazione.
 */
export function createRecordTypesListParamsValidator(
  registerRecordFieldVisibility: RegisterRecordFieldVisibility,
  customFieldsConfig: AlboConfigurazioneTipoCampoDTO[] = [],
): yup.ObjectSchema<NullableObject<any>> {
  // Definisce lo schema per i campi custom
  const customFieldsSchema =
    customFieldsConfig
      ?.filter(campo => campo[registerRecordFieldVisibility] && campo.codice)
      .reduce(
        (
          schema: Record<string, yup.AnySchema>,
          campo: AlboConfigurazioneTipoCampoDTO,
        ) => {
          if (!campo.codice) return schema;

          applyRecordTypesFieldValidators(campo, schema);

          return schema;
        },
        {} as Record<string, yup.AnySchema>,
      ) ?? {};

  // Costruisce lo schema completo
  return yup
    .object({
      // --- Campi Statici ---
      idTipoAlbo: yup.string().required('Il tipo di albo è obbligatorio'),

      idPratica: yup.string().notRequired().nullable(),
      idProcedimento: yup.string().notRequired().nullable(),
      idUfficio: yup.string().notRequired().nullable(),
      dataModificaDa: yup.string().notRequired().nullable(),
      dataModificaA: yup.string().notRequired().nullable(),
      codice: yup.string().notRequired().nullable(),
      numeroDa: yup.string().notRequired().nullable(),
      numeroA: yup.string().notRequired().nullable(),
      dataEmissioneDa: yup.string().notRequired().nullable(),
      dataEmissioneA: yup.string().notRequired().nullable(),
      statoIscrizione: yup.string().notRequired().nullable(),
      dataScadenzaDa: yup.string().notRequired().nullable(),
      dataScadenzaA: yup.string().notRequired().nullable(),
      pagina: yup.number().notRequired().nullable(),
      limite: yup.number().notRequired().nullable(),
      ordinamenti: yup
        .array()
        .of(yup.string().required())
        .notRequired()
        .nullable(),

      // --- Campi Dinamici ---
      ...customFieldsSchema,
    })
    .required()
    .noUnknown();
}
